import { Box, styled } from '@mui/material';

// Campo de búsqueda del sidebar (quick-jump). El foco usa el acento dorado
// (regla del sistema: foco de inputs = dorado permitido).
const StyledSidebarSearch = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.surface.overlay,
  border: `1px solid ${theme.palette.hairline.strong}`,
  borderRadius: '13px',
  color: theme.palette.text.secondary,
  cursor: 'text',
  display: 'flex',
  gap: theme.spacing(1),
  height: 44,
  marginBottom: theme.spacing(1.5),
  padding: theme.spacing(0, 1.5),
  transition: 'border-color 200ms cubic-bezier(0.32, 0.72, 0, 1)',
  '&:focus-within': {
    borderColor: theme.palette.gold.main
  }
}));

export default StyledSidebarSearch;
